(() => {})();
$(window).on('load', () => {
  const singleProject = document.querySelector('.singleProject__gallery');
  if (singleProject) {
    $(singleProject).slick({
      dots: true,
      arrows: true,
      infinite: true,
      // speed: 300,
      autoplay: true,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1
    });
    $('.singleProject__gallery__item').colorbox({
      rel: 'group1'
      // width: '80%'
      // innerHeight: '90%'
    });
  }

  const slider = document.querySelectorAll('.slider__wrapper');
  if (slider.length) {
    $(slider).slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 10000
    });
  }
  // console.log(window.innerWidth < 1150);
  // if (window.innerWidth < 1150) {
  const partners = document.querySelector('.row_partners__wrapper');
  if (partners) {
    $(partners).slick({
      dots: false,
      arrows: false,
      infinite: true,
      speed: 300,
      autoplay: true,
      autoplaySpeed: 900,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  const ourProject = document.querySelector('.row_fetch_post__wrapper');
  if (ourProject) {
    $(ourProject).slick({
      dots: false,
      arrows: false,
      infinite: true,
      // speed: 300,
      autoplay: true,
      autoplaySpeed: 1200,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1424,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  // }
});
